import { ICreateSubcontasUseCase } from "../../../presentation/useCases/create/create_subcontas_use_case";
import { IComercialRepository } from "../../repositories/comercial_repositories";

/**
 * CreateSubcontasUseCase
 */

export class CreateSubcontasUseCase implements ICreateSubcontasUseCase {
  constructor(private readonly repository: IComercialRepository) { }

  async execute(
    ativo: boolean,
    idSubcontaPai?: number,
    codigo?: string,
    descricao?: string,
  ): Promise<number> {
    return await this.repository.createSubconta(
      ativo,
      idSubcontaPai,
      codigo,
      descricao,
    );

  }
}
